module.exports = __webpack_public_path__ + "static/media/19_shape_r.8ed9dba9.webp";